import React from 'react'
import { useTranslation } from 'react-i18next'
import { Indicator } from 'is24-corecss'

interface ImageCounterBadgeIndicatorProps {
  currentIndex: number
  totalPictures: number
}

export const ImageCounterBadgeIndicator: React.FC<ImageCounterBadgeIndicatorProps> = ({
  currentIndex,
  totalPictures,
}) => {
  const { t } = useTranslation()

  if (totalPictures < 1) {
    return null
  }

  return (
    <Indicator.Root appearance='label' color='white' variant='flat' className='font-body-small-bold'>
      {t('wizard.screen.multimediaNewModalContent.mobile.pictureFrom', {
        current: currentIndex + 1,
        amount: totalPictures,
      })}
    </Indicator.Root>
  )
}
